import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { PermissionsHttpClient } from '@omnea-app/permissions/permissionsHttpClient'
import type { paths } from '@omnea-app/permissions/permissionsHttpClient/permissionsGeneratedTypes'

type RolesResponse = paths['/roles']['get']['responses'][200]['content']['application/json']
export type RoleSummary = RolesResponse['roles'][number]

export const RolesQueryKey = 'GetRoles'

export const useRoles = (options: { enabled?: boolean } = {}) => {
  const { getToken, user } = useAuthenticatedUser()
  return useQuery({
    queryKey: [RolesQueryKey, user.id],
    enabled: options.enabled ?? true,
    queryFn: async () => {
      const authorization = await getToken()
      const permissionsClient = new PermissionsHttpClient({ authorization })
      const { data, error } = await permissionsClient.GET('/roles')
      throwIfApiError(error)
      return data
    },
  })
}
